module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctn-duo-input row domain-selector-container"
  }, [_c('div', {
    staticClass: "left inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input form-elem-container ctn-select ctn-label custom-selector",
    class: {
      error: _vm.errors.has('domain_type')
    }
  }, [(!_vm.domainType) ? _c('label', {
    attrs: {
      "for": "select"
    }
  }, [_vm._v("Type de domaine")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.domainTypes,
      "data-vv-value-path": "mutableValue",
      "data-vv-name": "domain_type",
      "has-error": _vm.errors.has('domain_type')
    },
    model: {
      value: (_vm.domainType),
      callback: function($$v) {
        _vm.domainType = $$v
      },
      expression: "domainType"
    }
  })], 1), _vm._v(" "), (_vm.errors.has('domain_type')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('domain_type')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right inner-duo"
  }, [_c('div', {
    directives: [{
      name: "inputUI",
      rawName: "v-inputUI"
    }],
    staticClass: "ctn-input ctn-label",
    class: {
      error: _vm.errors.has('domain')
    }
  }, [_c('label', {
    attrs: {
      "for": "domain"
    }
  }, [_vm._v("Nom de domaine")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.domain),
      expression: "domain"
    }],
    attrs: {
      "type": "text",
      "name": "domain"
    },
    domProps: {
      "value": (_vm.domain)
    },
    on: {
      "change": _vm.domainUpdated,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.domain = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.errors.has('domain')) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('domain')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "domain-selector-trash"
  }, [_c('span', {
    staticClass: "icon-file-trash",
    on: {
      "click": function($event) {
        _vm.$emit('deleteDomain', _vm.index)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7e4e366"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/domain-selector.vue
// module id = 654
// module chunks = 1